/* « Vos demandes » is folded into the builder (merchant-experience review 08/10 C.2 move 4, gate-go word 10,
   Scope v5 errata B2): a quiz, a question, the retour privé and « Vos avis, en rotation » are created and
   changed in the demande sheet, from the visit that uses them (routes/campagnes/DemandeSheet.tsx); the
   platforms and the networks are Paramètres › Plateformes (routes/parametres/Plateformes.tsx). AskPreview.tsx
   stays here, the shared preview. This route only answers old links: « Plateformes » goes to its page,
   everything else to Vos campagnes, where every demande now lives. */
import { Navigate, useSearchParams } from 'react-router-dom'

export default function Reponses() {
  const [params] = useSearchParams()
  return <Navigate to={params.get('onglet') === 'liens' ? '/parametres/plateformes' : '/campagnes'} replace />
}
